<template>
    <div class="DispensationRecorder"> 
        <!--NEW DISPENSATION MODAL-->
        <b-modal  ref="modal-newdispensation" size="lg" title="RECORD DISPENSATION" hide-footer>
            <b-container>
                <b-form @submit="Save" v-if="TargetRecord.MedicationPhysicianOrder">
                    <b-row>
                        <b-col>
                            <h3 class="center-text">CLIENT INFO</h3>
                        </b-col>
                    </b-row>
                    <b-row>
                        <div class="col-4">
                            <div>
                                <img class="photo-border-square" v-bind:src="ProfilePhotoFileID" style="width:100%;border-radius:20px;" />
                            </div>
                        </div>
                        <div class="col-8">
                            <h2>{{TargetRecord.ClientName}}</h2>
                            <p>DOB: {{formatDate(TargetRecord.ClientDOB,'MM/DD/YYYY')}}</p>
                            <p class="bold"><span class="red">Allergies: </span>{{TargetRecord.ClientAllergies}}</p>
                        </div>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3 class="center-text">MEDICATION INFO</h3>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <p>Name: <span class="bold">{{TargetRecord.MedicationPhysicianOrder.Name}}</span></p>
                            <p>Strength: <span class="bold">{{TargetRecord.MedicationPhysicianOrder.Strength}}</span></p>
                            <p>Route: <span class="bold">{{TargetRecord.MedicationPhysicianOrder.Route}}</span></p>
                            <p>Dose(s): <span class="bold">{{TargetRecord.MedicationPhysicianOrder.DoseDescriptions}}</span></p>
                            <p>Warnings: <span class="bold">{{TargetRecord.MedicationPhysicianOrder.Warnings}}</span></p>
                        </b-col>
                        <b-col>
                            <p>Prescribed by: <span class="bold">{{TargetRecord.MedicationPhysicianOrder.PhysicianName}}</span></p>
                            <p>Physician Phone: <span class="bold">{{TargetRecord.MedicationPhysicianOrder.PhysicianPhoneNumber.FormattedPhoneNumber}}</span></p>
                            <p>Clinic Name: <span class="bold">{{TargetRecord.MedicationPhysicianOrder.Strength}}</span></p>
                            <p>Route: <span class="bold">{{TargetRecord.MedicationPhysicianOrder.ClinicName}}</span></p>
                            <p>Started: <span class="bold">{{formatDate(TargetRecord.MedicationPhysicianOrder.StartDateTime,'m/d/Y')}}</span></p>
                            <p>Medication Type: <span class="bold">{{TargetRecord.MedicationPhysicianOrder.MedicationType}}</span></p>
                            <p>Psychotropic: <span class="bold">{{TargetRecord.MedicationPhysicianOrder.IsPsychotropic}}</span></p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3 class="center-text">DOSE INFO</h3>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <p v-if="LastDispensation">Last Dose Given: <span class="bold">{{LastDispensation.QuantityDispensed}} on {{formatDate(LastDispensation.DispensedAt, 'm/d/Y h:mm A')}}</p>
                            <p>This Dose: <span class="bold">{{TargetRecord.QuantityDescription}}</span></p>
                            <div class="form-group">
                                <label>Date/Time Medication was Dispensed:</label>
                                <flat-pickr v-model="DispensationRecord.DispensedAt" class="form-control" :config="DateTimeConfig" required></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Dispensation Type:</label>
                                <select v-model="DispensationRecord.DispensationType" required class="form-control">
                                    <optgroup label="DISPENSED">
                                        <option value="Direct">Directly Dispensed by Olive Crest Staff</option>
                                        <option value="School">Given at School (non Olive Crest Staff)</option>
                                        <option value="TR">Taken by Client while on TR</option>
                                        <option value="Work">Taken by Client while at Work</option>
                                        <option value="DirectAlternateDoc">Dispensed by Olive Crest Staff (Documented Elsewhere)</option>
                                    </optgroup>
                                    <optgroup label="NOT DISPENSED">
                                        <option value="Withheld">Withheld (per physician's order)</option>
                                        <option value="Missed">Missed</option>
                                        <option value="Declined">Declined by Client</option>
                                    </optgroup>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Inventory:</label>
                                <select v-model="DispensationRecord.MedicationInventoryID" required class="form-control">
                                    <optgroup label="OPEN INVENTORY (USE FIRST)">
                                        <option v-for="inventory in OpenInventory" :value="inventory.MedicationInventoryID">
                                            Rx {{inventory.PrescriptionNumber}} ({{inventory.RemainingFilledString}}), Opened {{formatDate(inventory.DateOpened,'MM/DD/YY')}}
                                        </option>
                                    </optgroup>
                                    <optgroup label="REFILLS">
                                        <option v-for="inventory in RefillInventory" :value="inventory.MedicationInventoryID">
                                            Rx {{inventory.PrescriptionNumber}} ({{inventory.RemainingFilledString}}), Filled {{formatDate(inventory.DateFilled,'MM/DD/YY')}}
                                        </option>
                                    </optgroup>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Quantity Dispensed ({{TargetRecord.MedicationPhysicianOrder.UnitType}}):</label>
                                <input type="number" v-model="DispensationRecord.QuantityDispensed" class="form-control" step="0.1" required />
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Comments:</label>
                                <textarea rows="6" v-model="DispensationRecord.Comments" class="form-control"></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h4>This Medication is being Dispensed by: <span class="bold">{{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</span></h4>
                            <p>If you are not {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}, you must log out of the system and log in under your own profile.</p>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button v-if="TargetRecord.DispensationID && CheckPermission('Medication.Dispensation.Delete')" size="md" variant="danger" @click="Delete()">
                                DELETE
                            </b-button>
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button v-if="!TargetRecord.DispensationID" size="md" variant="success" type="submit">
                                RECORD DISPENSATION
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowLeft);
    import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowRight);
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faTrash } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrash);

    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    

    export default {
        props: [

        ],
        data: function () {
            return {
                TargetRecord: {},
                DispensationRecord: {},
                LastDispensation: null,
                ProfilePhotoFileID: null,
                AvailableInventory: [],
                //AUX
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
                DateTimeConfig: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y h:i K',
                },
            };
        },
        methods: {
            //API ENDPOINTS
            Save(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Medication/Dispensation", this.DispensationRecord, this.SaveSuccess, () => { }, true);
            },
            SaveSuccess() {
                this.$emit('updateddata');
                this.Cancel();
            },
            Delete() {
                this.$MasterAPI.ExecuteRequest("DELETE", "Medication/Dispensation/" + this.TargetRecord.DispensationID, {  }, this.DeleteSuccess, () => { }, true);
            },
            DeleteSuccess() {
                this.$emit('updateddata');
                this.Cancel();
            },
            GetLastDispensation(orderID) {
                this.$MasterAPI.ExecuteRequest("GET", "Medication/DispensationPlan/LastDispensation", { MedicationPhysicianOrderID: this.orderID }, this.GetLastDispensationSuccess, () => { }, true);
            },
            GetLastDispensationSuccess(response) {
                this.LastDispensation = response.data.data;
            },
            ProfilePhotoURL(clientSubProgramMembershipID) {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/FosterClients/GetPhotoID", { membershipClientSubProgramID: clientSubProgramMembershipID }, this.ProfilePhotoURLSuccess, () => { }, true);
            },
            ProfilePhotoURLSuccess(response) {
                if (response.data.data != null) {
                    this.ProfilePhotoFileID = this.$baseURL + '/API/Core/Files/GetFileContent/profilephoto?FileID=' + response.data.data;
                }
                else {
                    this.ProfilePhotoFileID = "/images/NoPhotoOnFile.jpg"
                }
            },
            GetAvailableInventory(orderID) {
                this.$MasterAPI.ExecuteRequest("GET", "Medication/DispensationPlan/AvailableInventory", { MedicationPhysicianOrderID: orderID }, this.GetAvailableInventorySuccess, () => { }, true);
            },
            GetAvailableInventorySuccess(response) {
                this.AvailableInventory = response.data.data;
            },
            //UI CONTROLS
            Open(doseInfo) {
                this.ProfilePhotoFileID = null;
                this.TargetRecord = JSON.parse(JSON.stringify(doseInfo));
                this.Lastdispensation = null;
                this.DispensationRecord = {
                    MedicationPhysicianOrderDoseID: doseInfo.MedicationPhysicianOrderDoseID,
                    DispensedAt: moment().format("YYYY-MM-DD HH:mm")
                };
                this.DispensationRecord.QuantityDispensed = doseInfo.Quantity;

                this.GetAvailableInventory(doseInfo.MedicationPhysicianOrderID);
                this.GetLastDispensation(doseInfo.MedicationPhysicianOrderID);
                this.ProfilePhotoURL(doseInfo.ClientSubProgramMembershipID);

                this.$refs["modal-newdispensation"].show();
            },
            Cancel() {
                this.$refs["modal-newdispensation"].hide();
            },
            


            //MISC
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DDThh:mm:ss').format(fmt)
            },
             CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            }
        },
        components: {
            flatPickr        },
        mounted() {

        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            },
            OpenInventory: function () {
                return this.AvailableInventory.filter(i => i.Status == "Open");
            },
            RefillInventory: function () {
                return this.AvailableInventory.filter(i => i.Status == "Refill");
            }
        }
    }
</script>

<style scoped>

    .center-cells td, .center-cells th {
        text-align: center;
    }

    table td, table th {
        border-style: solid;
    }
</style>